import React, { useEffect, useState } from '../../../_snowpack/pkg/react.js';
import { colors } from '../../css/index.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import WeirdFlex from '../../images/illustrations/budget-alert.svg';
import { useTenant } from '../../hooks/index.js';
import { useQuery } from '../../../_snowpack/pkg/@apollo/react-hooks.js';
import { GET_TENANT_METRICS } from './graph.js';
const Toast = styled.div.withConfig({
  displayName: "budget-alert__Toast",
  componentId: "l5ajc4-0"
})(["z-index:1;right:0;position:fixed;bottom:0;left:0;padding:0 100px;width:100%;background:", ";isolation:isolate;"], colors.glacierLighter);
const Inner = styled.div.withConfig({
  displayName: "budget-alert__Inner",
  componentId: "l5ajc4-1"
})(["max-width:1060px;margin:0 auto;position:relative;border:1px solid transparent;p{font-size:15px;color:#4c776d;padding-left:100px;strong{padding-right:15px;font-size:16px;}button{appearance:none;border:none;padding:0;display:inline-block;background:transparent;text-decoration:underline;margin-left:5px;color:inherit;cursor:pointer;font-size:inherit;&:hover{text-decoration:none;}}}"]);
const Illustration = styled.div.withConfig({
  displayName: "budget-alert__Illustration",
  componentId: "l5ajc4-2"
})(["width:90px;position:absolute;bottom:-1px;overflow:hidden;img{margin-bottom:-30px;width:100%;}"]);
const TENANT_PLAN_URL = 'https://shop.crystallize.com/api/tenant/';
const tenantsWithPaperPlan = ['bos-ecom-prod', 'bos-ecom-preprod', 'bos-ecom-test', 'bos-ecom-devtest', 'bos-ecom-qa'];
export default function UsageAlert() {
  const {
    tenant: {
      id: tenantId,
      identifier: tenantIdentifier
    }
  } = useTenant();
  const initialMetrics = {
    items: {
      count: 0
    },
    apiCalls: {
      count: 0
    },
    order: {
      count: 0
    },
    webhooks: {
      count: 0
    },
    bandwidth: {
      count: 0
    }
  };
  const [planName, setPlanName] = useState('');
  const [notify, setNotify] = useState(false);
  const [metrics, setMetrics] = useState(initialMetrics);
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const startDate = getIsoDate(year, month, true);
  const endDate = getIsoDate(year, month, false);
  const {
    data
  } = useQuery(GET_TENANT_METRICS, {
    variables: {
      startDate,
      endDate,
      tenantId
    }
  });
  useEffect(() => {
    var _data$tenant, _data$tenant$get, _data$tenant2, _data$tenant2$get;

    if (data !== null && data !== void 0 && (_data$tenant = data.tenant) !== null && _data$tenant !== void 0 && (_data$tenant$get = _data$tenant.get) !== null && _data$tenant$get !== void 0 && _data$tenant$get.metrics) setMetrics(data === null || data === void 0 ? void 0 : (_data$tenant2 = data.tenant) === null || _data$tenant2 === void 0 ? void 0 : (_data$tenant2$get = _data$tenant2.get) === null || _data$tenant2$get === void 0 ? void 0 : _data$tenant2$get.metrics);
  }, [data]);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const getPlan = async () => {
      const response = await fetch(`${TENANT_PLAN_URL}${tenantId}`);
      if (response.type === 'error') console.error('Could not fetch tenant plan');else {
        var _await$response$json;

        const {
          success,
          tenant
        } = (_await$response$json = await (response === null || response === void 0 ? void 0 : response.json())) !== null && _await$response$json !== void 0 ? _await$response$json : {};
        if (success && tenant !== null && tenant !== void 0 && tenant.plan) setPlanName(tenant.plan.name);
      }
    };

    getPlan();
  }, [tenantId]);
  /**TODO: Confirm the algorithm to show user when FREE tier limit has exceeded**/

  useEffect(() => {
    var _metrics$items;

    if (metrics && planName && (metrics === null || metrics === void 0 ? void 0 : (_metrics$items = metrics.items) === null || _metrics$items === void 0 ? void 0 : _metrics$items.count) >= 1000) setNotify(true);
  }, [metrics, planName]);

  if (tenantIdentifier && tenantsWithPaperPlan.includes(tenantIdentifier)) {
    return null;
  }

  return notify && /*#__PURE__*/React.createElement(Toast, null, /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(Illustration, null, /*#__PURE__*/React.createElement("img", {
    src: WeirdFlex,
    alt: "Weird man flexing"
  })), /*#__PURE__*/React.createElement("p", null, "Looks like you will soon hit the FREE tier limits!", /*#__PURE__*/React.createElement("button", {
    onClick: () => setNotify(false)
  }, "Close"))));
}

const getIsoDate = (year, month, start) => {
  const firstDay = 1;
  const lastDay = new Date(year, month + 1, 0).getDate();
  return new Date(Date.UTC(year, month, start ? firstDay : lastDay)).toISOString();
};